import { render, staticRenderFns } from "./ToolbarFeedbackAction.vue?vue&type=template&id=0f885d04&"
import script from "./ToolbarFeedbackAction.vue?vue&type=script&lang=ts&"
export * from "./ToolbarFeedbackAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GFaIcon from 'shared/global/components/FaIcon.vue'
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {GFaIcon,VBtn,VToolbarItems,VTooltip})
